/*
  /women トップを LINE のリッチメニューと配信カードの色と地に着せ替えた見本 (2026-10-20 代表「情報は今のまんまで、色とか背景とかだけ変えてみる」)。
  文言、並び、写真、字の大きさ、レイアウトは変えない。変えるのは色、地、線、札の塗り、ボタンの色だけ。
  寄せる先は無料カウンセリング (pages/liff/counseling-line-tone.ts) と同じ値。
  緑 #05B45B (札の地、アイコン)、字に使う濃い緑 #037F40、線と字と黒い札 #141414、黄のマーカー #FFE566、ボタン #D9F99D に #141414 の縁。

  効かせる範囲は .hp.hp-home.hp-line だけ。この印は IndexPage (トップ) だけが付ける。
  sec-women-tone.ts の WOMEN_TONE_VARS は LP 群 (pages/lp/women-tone.ts) も読むので書き換えず、同じ変数名をこの印の下で上書きする。
  HP_HOME_WOMEN_CSS の後ろに足すので、同じ強さの規則は後から来るこちらが勝つ。
  見せ場を絞る決まりは残す。濃い地 (淡い緑のグラデとドット) は最初の画面、作るもの (#projects)、締め (#consult) の 3 か所だけ。間は白とごく淡い緑
*/
import { WARM_BUTTON_CSS } from "./sec-women-btn";
const L = ".hp.hp-home.hp-line";
const INK = "#141414";
const GREEN = "#05B45B";
const GREEN_INK = "#037F40";
const ON_GREEN = "#14231A";
const YELLOW = "#FFE566";
const LIME = "#D9F99D";
const DOTS = "radial-gradient(circle,rgba(5,180,91,.28) 1.5px,transparent 1.9px) 0 0/18px 18px";
const WASH = "linear-gradient(160deg,#F2FCE8 0%,#DDF6E6 55%,#CDEFFA 100%)";
const SHOW = `${DOTS},${WASH}`;
const SOFT = "#F7FCF4";
const HAIR = "#CFDDCF";
const CARD_EDGE = "#D9D9D0";

export const VARS = `
${L}{
  --w-bg:#fff;--w-blush:${SOFT};--w-blush-2:#F2F9EE;--w-blush-3:#E3F3E8;
  --w-ink:${INK};--w-head:${INK};--w-sub:#3D3D3D;--w-note:#4A4A4A;
  --w-rose:${GREEN};--w-rose-ink:${GREEN_INK};--w-rose-soft:#9AD9B5;--w-mark:${YELLOW};
  --w-cta:${LIME};--w-cta-edge:${INK};--w-cta-hover:#CBF37F;--w-cta-press:#BDE96F;--w-cta-ink:${GREEN_INK};
  --w-navy:${INK};--w-navy-2:${INK};--w-teal:${GREEN};--w-aqua:#CDEFFA;
  --w-ground-alt:${SOFT};--w-ground-line:#DDEBDD;
  --w-grad-pink:#F2FCE8;--w-grad-lilac:#DDF6E6;--w-grad-sky:#CDEFFA;
  --w-show-grad:${SHOW};
  --w-end-wash:${WASH};
  --w-show-grad-v:${WASH};
  --w-rose-deep:${GREEN_INK};--w-sub-deep:#2E2E2E;--w-note-deep:#3D3D3D;
  --w-band-dim:#3D3D3D;--w-band-rule:rgba(20,20,20,.2);--w-band-edge:#F2FCE8;
  --w-rule:${HAIR};--w-shadow:none;
  --red:${INK};--focus-ring:${GREEN_INK};
  --grad:radial-gradient(60% 80% at 10% 10%,#E4F7EA 0,transparent 70%),radial-gradient(60% 70% at 90% 90%,#CDEFFA 0,transparent 70%),linear-gradient(#fff,#fff);
  background:#fff;
}
${L} :is(.hx-dark,.hx-blue,.bp,.hx-pband){--focus-ring:${GREEN_INK}}
${L} .hp-fv{--focus-ring:${GREEN_INK};--mm-line:${INK};--mm-dim:#6B6B6B}
`;

/* 地。濃い地は 3 か所だけ、淡い緑のグラデにドット。間は白とごく淡い緑 */
const GROUND = `
${L} #projects{background:${SHOW}!important}
${L} #consult{background:${SHOW}!important}
${L} .hx-end{background:${SHOW}!important}
${L} .hx-band{background:${SOFT}}
${L} .hx-wyg-boxin{background:#EAF8EE!important}
${L} .hp-fv{background:${SHOW}}
${L} .hp-fv-bg{-webkit-mask-image:linear-gradient(180deg,#000 36%,transparent 86%);mask-image:linear-gradient(180deg,#000 36%,transparent 86%)}
${L} .hp-fv-bg::after{background:none}
@media (min-width:768px){
  ${L} .hp-fv{background:${DOTS},linear-gradient(160deg,#F2FCE8 0%,#DDF6E6 55%,#CDEFFA 100%)}
  ${L} .hp-fv-bg{-webkit-mask-image:linear-gradient(0deg,transparent 0,#000 38%);mask-image:linear-gradient(0deg,transparent 0,#000 38%)}
  ${L} .hp-fv-bg::after{background:none}
}
${L} .hx-pband-photo::after{background:linear-gradient(to right,#F2FCE8 0,rgba(242,252,232,.55) 14%,rgba(242,252,232,0) 36%)!important}
${L} .hx-end-photo::after{background:linear-gradient(180deg,rgba(221,246,230,0) 45%,rgba(221,246,230,.95) 100%)!important}
${L} .hx-pband{background:${SOFT}!important}
${L} .card-open-hint{background:rgba(20,20,20,.88)}
@media (min-width:768px){${L} .md\\:bg-\\[\\#1a1a1a\\]\\/92{background-color:rgba(20,20,20,.9)}}
${L} .hx-end-credit{text-shadow:none}
`;

/* 札と箱。白地に #141414 の 2px の縁、影なし。罫の行は緑がかった灰 */
export const CARD = `
${L} :is(.pp-pt-frame,.pp-vs-frame){border:2px solid ${INK}!important;box-shadow:none!important;background:transparent!important}
${L} :is(.em-card,.hx-wyg-card,.pp-pay-card,.pp-sim,.hx-vc,.fq-item,.hx-frame,.hx-pd-shot,.hx-grant,.hx-scope-cards li,.px-pc,.px-grp,.hx-end-step){border:1px solid ${CARD_EDGE}!important;box-shadow:none!important}
${L} #projects .px-pc{border:1px solid ${CARD_EDGE}!important}
${L} :is(.hx-wyg-list,.pp-pay-note,.hx-i-crit-l li,.hx-qi){border-color:${HAIR}!important}
${L} .hx-frame-bar{border-bottom-color:${INK}}
${L} :is(.em-b-base,.em-do .em-it,.em-lg-all,.hx-kd-h,.hx-pb-a,.pp-pay-tag,.pp-pt thead th.yes,.pp-sim-h,.pp-vs thead th.yes,.hx-lv-b,.hx-lv-a,.hx-lv-p){box-shadow:none!important;border:2px solid ${INK}}
${L} .hx-fv-facts,${L} .hp-fv-facts{background:#fff;border:2px solid ${INK};box-shadow:none}
${L} .hp-fv-fact:not(:nth-child(2n+1)){border-left-color:${HAIR}}
${L} .hx-scope-row .hx-scope-track .hx-scope-short{border-top-color:#9DB09F}
/* 相談の手順の番号は LINE の緑 (#06C755、白地で 2.26) をやめ、ブランドの緑の地に墨の字にする。7 つとも同じ */
${L} .hx-end-no,${L} .hx-end-no-line{background:${GREEN}!important;border-color:${GREEN}!important;color:${ON_GREEN}!important}
/* 締めの 7 段の札の絵。札の角 (2px) に絵の角を合わせ、白い三角を出さない。絵の丸みは tone の var(--w-r) (16px) が付けていた */
${L} .hx-end-step .hx-end-pic{border-radius:2px 2px 0 0}
${L} .hx-end-step:nth-child(5) .hx-end-pic{border-radius:2px 0 0 2px}
@media (min-width:900px){${L} .hx-end-step:nth-child(5) .hx-end-pic{border-radius:2px 2px 0 0}}
${L} .hx-end-flow[data-hx-row]>.hx-end-step:nth-child(n) .hx-end-pic{border-radius:2px 2px 0 0}
${L} .hp-fv-facts{border-width:2px}
${L} .em-down{background:#FFF5BF;color:${INK}}
`;

/* 札の塗りと選んだ状態。緑の地の字は黒 */
export const FILL = `
${L} :is(.em-ng,.em-no,.pp-pay-ni,.pp-pt-ck,.px-grp-tag,.hx-flag){background-color:${GREEN}!important;color:${ON_GREEN}!important}
${L} :is(.em-ng,.em-no,.pp-pay-ni,.pp-pt-ck,.px-grp-tag,.hx-flag) *{color:${ON_GREEN}!important}
${L} :is(.hx-dark,.hx-blue) .hx-flag{background:${GREEN};color:${ON_GREEN}}
${L} :is(.hx-pd-tab[aria-current=true],.pp-sim-seg [aria-checked="true"]){background:${GREEN}!important;color:${ON_GREEN}!important}
${L} :is(.hx-pd-tab[aria-current=true],.pp-sim-seg [aria-checked="true"]) *{color:${ON_GREEN}!important}
${L} .hx-pd-prog{background:${INK}}
${L} .hp-fv-label span{border-color:${GREEN}}
${L} .bp-home,${L} .bp{--bp-y:${GREEN}}
${L} .bp-home [fill="#FFE566"],${L} .bp-home-g [fill="#FFE566"]{fill:${GREEN}}
${L} .bp-home-g [stroke="rgba(255,255,255,.5)"]{stroke:rgba(20,20,20,.42)}
${L} .hx-pb-arrow{border-left-color:#fff}
${L} .bp-m30 .bp-m30-c{background:${GREEN}}
${L} .bp-m30 .bp-m30-c.is-after{background:#fff;border-color:${GREEN_INK}}
${L} .pp-pay-fig rect[fill="#0E0E10"]{fill:${GREEN}}
${L} .pp-pay-fig text[fill="#fff"]{fill:${INK}}
${L} .pp-pay-fig [stroke="#0E0E10"]{stroke:${INK}}
${L} .pp-pay-fig text[fill="#0E0E10"]{fill:${INK}}
${L} .hx-end-photo{background:transparent}
`;

/* ボタン。主なボタンと副のボタンの形と色は sec-women-btn.ts。ここには、動画の再生ボタンなど、その形にしないものを残す。LINE の緑は今のまま */
export const BUTTON = `
${WARM_BUTTON_CSS}
${L} .hx-prv-btn{background:${LIME};color:${INK};box-shadow:inset 0 0 0 3px ${INK}}
${L} .hx-prv-btn :is(svg,path){color:${INK};fill:${INK}}
${L} .fixed.inset-x-0.bottom-0>.bg-\\[\\#1a1a1a\\]{border-color:${INK};border-width:2px}
${L} .decoration-\\[\\#1F56D6\\]{text-decoration-color:${GREEN}}
`;

/* ヘッダーとフッター (.hp の外)。上の帯は淡い緑の地に黒い札、予約の札は黄緑 */
export const CHROME = `
html:has(.hp-line.hp-home) :is(.gh-bar,.gh-drawer,.gh-secrow){--gh-ink:${INK};--gh-sub:#3D3D3D;--gh-blue:${GREEN_INK};--gh-wash:${SOFT};--gh-focus:${GREEN_INK}}
html:has(.hp-line.hp-home) .gh-bar{border-bottom-color:${INK}}
html:has(.hp-line.hp-home) :is(.gh-dhead){border-bottom-color:${HAIR}}
html:has(.hp-line.hp-home) .gh-drawer{border-right-color:${INK}}
html:has(.hp-line.hp-home) .gh-tag{border-left-color:${HAIR}}
`;


/* 押せる札の hover。/luagate の札 (lg-motion.css) と同じ動きを、この印の下だけで。マウスのある画面だけ動かし、指の画面と動きを減らす設定では止める。
   押せる札は職種の札 (rlx-card)、作るものの札 (px-pc)、受講生の声の動画の札 (hx-vf-box)。説明だけの箱には付けない */
const HOVER_T = "transform 250ms cubic-bezier(.22,1,.36,1),box-shadow 250ms cubic-bezier(.22,1,.36,1),border-color 250ms cubic-bezier(.22,1,.36,1),background-color 150ms ease-out";
const HOVER = `
${L} :is(.rlx-card,.px-pc,.hx-vf-box){transition:${HOVER_T}}
${L} .hx-vf-box{position:relative}
${L} .hx-vfilms>.hx-vf{transition:none}
${L} :is(.px-pc) .px-pc-shot img{transition:transform 400ms cubic-bezier(.22,1,.36,1)}
${L} .hx-vf-box:has(button)::after{content:"";position:absolute;inset:0;z-index:2;pointer-events:none;background:linear-gradient(105deg,rgba(255,255,255,0) 35%,rgba(255,255,255,.55) 50%,rgba(255,255,255,0) 65%);transform:translateX(-120%)}
@media (hover:hover){
  ${L} :is(.rlx-card,.px-pc):hover,${L} #projects .px-pc:hover,${L} .hx-vf-box:has(button):hover{transform:translateY(-4px);border-color:${INK}!important;box-shadow:0 4px 0 0 ${INK}!important}
  ${L} .hx-vfilms>.hx-vf:hover{transform:none}
  ${L} .px-pc:hover .px-pc-shot img{transform:scale(1.06)}
  ${L} .hx-vf-box:has(button):hover::after{transform:translateX(120%);transition:transform 900ms cubic-bezier(.22,1,.36,1)}
}
${L} :is(.rlx-card,.px-pc,.hx-vf-box:has(button)):active{transform:translateY(-1px);box-shadow:0 1px 0 0 ${INK}!important;transition-duration:80ms}
${L} :is(.rlx-card,.px-pc,.hx-vf-box button):focus-visible{outline:2px solid ${INK};outline-offset:2px}
@media (prefers-reduced-motion:reduce){
  ${L} :is(.rlx-card,.px-pc,.hx-vf-box),${L} .px-pc .px-pc-shot img{transition:none!important}
  ${L} :is(.rlx-card,.px-pc,.hx-vf-box:has(button)):is(:hover,:active){transform:none!important}
  ${L} .px-pc:hover .px-pc-shot img{transform:none!important}
  ${L} .hx-vf-box:has(button)::after{display:none}
}
`;

/* 細部の直し (10/20 のレビュー)。地の取り残し、名前の札、透かし文、はみ出し、アイコンの色、スマホの目次 */
const FIX = `
${L}{--plan-ic:${YELLOW}}
${L} svg[data-plan-id]{--ic-mark:${YELLOW}!important}
${L} :is(.hx-pdt-plate,.hx-pdt-dlg){background:#FDFDFA}
${L} .em-ic.em-part{background:#D9F2E4}
${L} .bp>.bgp{opacity:.5}
/* 明るい地では紙面の罫と広告の枠が薄い線だけ残って見えるので、罫と枠は出さない (縦書きの字だけ残す) */
${L} .bp>.bgp :is(.bgp-band,.bgp-col,.bgp-art b){border:0!important}
${L} .bp>.bgp .bgp-ad{display:none}
${L} .hx-i-over{background:linear-gradient(to top,rgba(20,20,20,.4) 0,rgba(20,20,20,.4) 100%);padding-top:10px}
${L} .hx-i-role{margin-top:8px}
${L} .pp-sim-chips{flex-wrap:wrap;overflow-x:visible}
${L} .pp-sim-chip{flex:1 1 0;min-width:44px;padding:0 2px}
${L} .hx-pb-track{overflow:hidden}
@media (max-width:640px){${L} .hx-pb-arrow{display:none}}
@media (max-width:429px){
  html:has(.hp-line.hp-home) .gh-secrow a .gh-ic{display:none}
  html:has(.hp-line.hp-home) .gh-secrow a{padding:0 6px}
  html:has(.hp-line.hp-home) .gh-secrow a[href="#faq"]{font-size:0}
  html:has(.hp-line.hp-home) .gh-secrow a[href="#faq"]::after{content:"質問";font-size:12px}
}
/* 幅 360 でも、PC と同じ順の6つが横に送らずに入る (「料金」「質問」は指で押せる 44px のまま) */
@media (max-width:389px){
  html:has(.hp-line.hp-home) .gh-secrow ul{padding:0 2px}
  html:has(.hp-line.hp-home) .gh-secrow a{padding:0 5px}
}
`;

/* 見出しの強調と太さ (10/20 代表「大事な語だけ濃い緑に」「font weight が小さいな」)。
   大見出しは Zen Kaku Gothic New の 900 (LINE のカードと同じ)。900 は deferred-google-fonts.ts で読む。字間は太くなると詰まって見えるので .04em に。
   小見出し (h3、札の題) は今の 700 のまま。30ヶ月の見出しは Klee One 600 だけを読むので太字にしない */
const TYPE = `
${L} .hx-gr{color:${GREEN_INK};text-decoration:none;font-style:normal}
@media (max-width:480px){${L} .hx-pband-h{letter-spacing:0}}
${L} :is(.hp-fv-h,.hx-h2,.em-h2,.hx-pband-h,.bp-h){font-weight:900;letter-spacing:.04em}
${L} #bp-m30-h{font-weight:600;letter-spacing:.04em}
${L} .hx-h2 :is(del,mark,.hx-hl){font-weight:inherit}
`;

export const HP_HOME_LINE_CSS = (VARS + GROUND + CARD + FILL + BUTTON + HOVER + CHROME + FIX + TYPE)
  .replace(/\/\*[\s\S]*?\*\//g, "")
  .replace(/\n\s+/g, "\n");
